import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../components/Buttons';
import { View } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { Modal, ModalControls } from '../../../../components/Modal';
import { selectWorks } from '../../../Api/selectors';
import { performAction } from '../../actions';
import { REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { Cell } from '../Cell';
import { PerformActionButton } from '../PerformActionButton';
import { BaseCellComp } from '../BaseCellComp';
import { CellButton, CellButtons } from '../CellButton';
import { Well } from '../../../../components/Well';
import { VBox } from '../../../../components/Box';

const Container = styled.div`
  .formField {
    width: 100%;
    .form-controlField {
      > div {
        width: 100%;
      }
    }
  }
`;

const STATE = {
  approve: false,
};

/* eslint-disable react/prefer-stateless-function */
class BASE_USER_CELLComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  confirm() {
  }

  get user() {
    return this.props.cell.user;
  }

  renderApprove() {
    if (!this.state.approve) return null;

    return (
      <Modal onClose={this.reset.bind(this)} title={this.props.action.label}>
        {/*<WithVehicle vehicle_id={this.vehicle.id}>*/}

        {/*  <ModalControls>*/}
        {/*    <PerformActionButton action={this.props.action} target={this.company} onChange={this.reset.bind(this)} />*/}
        {/*    <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>*/}
        {/*  </ModalControls>*/}
        {/*</WithVehicle>*/}
      </Modal>
    );
  }

  render() {
    const user = this.user;
    return (
      <Cell>
        <Container>
          {/*<VehicleHeader vehicle={vehicle} />*/}
          {user.id}
          {user.name}
          {user.surname}

          <CellButtons>
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <>
                <CellButton
                  // onClick={this.setStateFn({ approve: !this.state.approve, || '' })}
                >
                  <View />
                </CellButton>
              </>
            )}
          </CellButtons>
        </Container>
        {this.renderApprove()}
      </Cell>
    );
  }
}

BASE_USER_CELLComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([`${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.user.id}`]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    // confirm(vehicle_id, regplate_code) {
    //   dispatch(performAction(ownProps.action.id, vehicle_id, { regplate_code }));
    // },
    // print() {
    //   dispatch(setVehicleProperty(ownProps.cell.vehicle.id, 'label_printer_queue', '1'));
    // },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const BASE_USER_CELL = compose(
  withConnect,
  withRouter,
)(BASE_USER_CELLComp);
